export default __webpack_public_path__ + "static/Card30-ea7fbc06f40bd3198c247bdae62fd196.png";